// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--hWT7f","button":"button--TRFSR","buttonWrapper":"buttonWrapper--Uur1a","toggledButton":"toggledButton--GFa_K button--TRFSR","content":"content--nfgvT"};